import React, { useState, useEffect } from 'react';
import { apiV2 } from '../../services/api';
import RelatedVacancyCard from '../RelatedVacancyCard';

// Componente para buscar e exibir vagas do mesmo departamento
function RelatedVacancies({ vacancy, company, currentLabel, utm_source, utm_campaign, utm_medium }) {
  const [relatedVacancies, setRelatedVacancies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentDepartment, setCurrentDepartment] = useState('');

  useEffect(() => {
    async function loadRelatedVacancies() {
      setLoading(true);
      try {
        const currentVacancyId = vacancy?.id;
        
        if (!currentVacancyId) {
          setLoading(false);
          return;
        }

        const vacanciesUrl = currentLabel.includes('/')
          ? `vacancies/per-departments/${currentLabel.split('/')[0]}/${currentLabel.split('/')[1]}`
          : `vacancies/per-departments/${currentLabel}`;

        // Buscar todas as vagas sem filtro por departamento
        const { data } = await apiV2.post(vacanciesUrl, {});
        
        // Variáveis para armazenar o departamento e as vagas relacionadas
        let foundDepartment = null;
        let departmentVacancies = [];
        
        // Verificação de segurança mais robusta para evitar erros
        if (data && data.data && data.data.vacancies && Array.isArray(data.data.vacancies) && data.data.vacancies.length > 0) {
          // Iterar por cada departamento
          for (const dept of data.data.vacancies) {
            if (dept && dept.items && Array.isArray(dept.items) && dept.items.length > 0) {
              // Verificar se a vaga atual está neste departamento
              const foundVacancy = dept.items.find(item => item && item.id === currentVacancyId);
              if (foundVacancy) {
                // Encontramos o departamento correto!
                foundDepartment = dept;
                departmentVacancies = dept.items.filter(item => item && item.id !== currentVacancyId);
                break;
              }
            }
          }
        } else {
          console.warn('API response data structure is invalid for related vacancies:', data);
        }
        
        // Se encontramos o departamento, atualizamos os estados
        if (foundDepartment) {
          setCurrentDepartment(foundDepartment.department);
          setRelatedVacancies(departmentVacancies);
        } else {
          setRelatedVacancies([]);
        }
      } catch (error) {
        console.error('Erro ao buscar vagas relacionadas:', error);
        setRelatedVacancies([]);
      }
      setLoading(false);
    }

    loadRelatedVacancies();
  }, [vacancy?.id, currentLabel]);

  // Não mostrar o componente se não houver vagas relacionadas
  if ((!relatedVacancies || relatedVacancies.length === 0) && !loading) {
    return null;
  }

  return (
    <div style={{ 
      padding: '40px 0'
    }}>
      <div style={{ 
        width: '100%',
        margin: '0 auto', 
        padding: '0 40px' 
      }}>
        <h2 style={{ 
          fontSize: '22px', 
          color: '#667085', 
          marginBottom: '28px',
          textAlign: 'center',
          fontWeight: 'normal'
        }}>
          Outras vagas de {currentDepartment}
        </h2>

        {loading ? (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100px'
          }}>
            <p>Carregando vagas relacionadas...</p>
          </div>
        ) : (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          }}>
            {relatedVacancies.slice(0, 5).map((relatedVacancy) => (
              <RelatedVacancyCard 
                key={relatedVacancy.id}
                vacancy={relatedVacancy}
                company={company}
                currentLabel={currentLabel}
                utm_params={{ utm_source, utm_campaign }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default RelatedVacancies; 